import {
  BrowserRouter as Router,
  Route,
  Routes,
  useLocation,
} from "react-router-dom";
import { useEffect, useState } from "react";

import "./App.css";
import "./components/Works/Works.css";

import ABOUT from "./components/About/ABOUT";
import ScrollRail from "./components/ScrollRail/ScrollRail";
import Loader from "./components/Loader/Loader";

import HomePage from "./components/HomePage/HomePage";
import Works from "./components/Works/Works";
import NavBar from "./components/NavBar/NavBar";
import Contact from "./components/Contact/Contact";

import PAWF from "./components/Works/PAWF";
import COURSE from "./components/Works/COURSE";
import PERFUME from "./components/Works/PERFUME";
import RESORT from "./components/Works/RESORT";
import Resume from "./components/Resume/Resume";

function AppContent() {
  const location = useLocation();

  useEffect(() => {
    const cursor = document.createElement("div");
    cursor.className = "cursor-plus";
    cursor.innerText = "✚";
    document.body.appendChild(cursor);

    const moveCursor = (e) => {
      cursor.style.left = e.clientX + "px";
      cursor.style.top = e.clientY + "px";
    };

    const hideCursor = () => {
      cursor.style.opacity = "0";
    };

    const showCursor = () => {
      cursor.style.opacity = "1";
      cursor.innerText = "✚";
      cursor.style.transform = "translate(-50%, -50%)";
      cursor.style.color = "#40e0d0";
      cursor.style.fontFamily = "Arial, sans-serif";
      cursor.style.fontSize = "44px";
      cursor.style.letterSpacing = "0";
      cursor.style.lineHeight = "1";
      cursor.style.whiteSpace = "normal";
    };

    const showGridCursor = () => {
      cursor.style.opacity = "1";
      cursor.innerText = "❖";
      cursor.style.transform = "translate(-50%, -50%) rotate(45deg)";
      cursor.style.color = "#40e0d0";
      cursor.style.fontFamily = "Arial, sans-serif";
      cursor.style.fontSize = "44px";
      cursor.style.letterSpacing = "0";
      cursor.style.lineHeight = "1";
      cursor.style.whiteSpace = "normal";
    };

    const showLinkedInCursor = () => {
      cursor.style.opacity = "1";
      cursor.innerText = "LinkedIn";
      cursor.style.transform = "translate(-50%, -50%)";
      cursor.style.color = "#000000";
      cursor.style.fontFamily = "'IBM Plex Mono', monospace";
      cursor.style.fontSize = "0.7rem";
      cursor.style.letterSpacing = "0.2em";
      cursor.style.lineHeight = "1";
      cursor.style.whiteSpace = "nowrap";
    };

    const showIVCCProposalCursor = () => {
      cursor.style.opacity = "1";
      cursor.innerText = "ⓘV  Chamber Website Proposal";
      cursor.style.transform = "translate(-50%, -50%)";
      cursor.style.color = "#000000";
      cursor.style.fontFamily = "'IBM Plex Mono', monospace";
      cursor.style.fontSize = "0.7rem";
      cursor.style.letterSpacing = "0.12em";
      cursor.style.lineHeight = "1.4";
      cursor.style.whiteSpace = "nowrap";
    };

    const showAboutCursor = () => {
      cursor.style.opacity = "1";
      cursor.innerText = "ABOUT";
      cursor.style.transform = "translate(-50%, -50%)";
      cursor.style.color = "#ffffff";
      cursor.style.fontFamily = "'IBM Plex Mono', monospace";
      cursor.style.fontSize = "0.7rem";
      cursor.style.letterSpacing = "0.2em";
      cursor.style.lineHeight = "1";
      cursor.style.whiteSpace = "nowrap";
    };

    window.addEventListener("mousemove", moveCursor);

    const worksNavLink = document.querySelector(".works-link");
    const linkedInLink = document.querySelector(".nav-in");
    const ivccProposalLink = document.querySelector(
      ".ivcc-proposal-link"
    );

    const navLinks = document.querySelectorAll(
      ".site-links a:not(.works-link)"
    );

    const overlayWorksLinks = document.querySelectorAll(
      ".overlay-works-link"
    );

    const aboutButtons = document.querySelectorAll(".about-trigger");

    navLinks.forEach((link) => {
      link.addEventListener("mouseenter", hideCursor);
      link.addEventListener("mouseleave", showCursor);
    });

    if (linkedInLink) {
      linkedInLink.addEventListener(
        "mouseenter",
        showLinkedInCursor
      );

      linkedInLink.addEventListener(
        "mouseleave",
        showCursor
      );
    }

    if (ivccProposalLink) {
      ivccProposalLink.addEventListener(
        "mouseenter",
        showIVCCProposalCursor
      );

      ivccProposalLink.addEventListener(
        "mouseleave",
        showCursor
      );
    }

    overlayWorksLinks.forEach((link) => {
      link.addEventListener("mouseenter", showGridCursor);
      link.addEventListener("mouseleave", showCursor);
    });

    if (worksNavLink) {
      worksNavLink.addEventListener(
        "mouseenter",
        showGridCursor
      );

      worksNavLink.addEventListener(
        "mouseleave",
        showCursor
      );
    }

    aboutButtons.forEach((btn) => {
      btn.addEventListener("mouseenter", showAboutCursor);
      btn.addEventListener("mouseleave", showCursor);
    });

    /* CLEANUP */
    return () => {
      window.removeEventListener("mousemove", moveCursor);

      navLinks.forEach((link) => {
        link.removeEventListener("mouseenter", hideCursor);
        link.removeEventListener("mouseleave", showCursor);
      });

      if (linkedInLink) {
        linkedInLink.removeEventListener(
          "mouseenter",
          showLinkedInCursor
        );

        linkedInLink.removeEventListener(
          "mouseleave",
          showCursor
        );
      }

      if (ivccProposalLink) {
        ivccProposalLink.removeEventListener(
          "mouseenter",
          showIVCCProposalCursor
        );

        ivccProposalLink.removeEventListener(
          "mouseleave",
          showCursor
        );
      }

      overlayWorksLinks.forEach((link) => {
        link.removeEventListener(
          "mouseenter",
          showGridCursor
        );

        link.removeEventListener(
          "mouseleave",
          showCursor
        );
      });

      if (worksNavLink) {
        worksNavLink.removeEventListener(
          "mouseenter",
          showGridCursor
        );

        worksNavLink.removeEventListener(
          "mouseleave",
          showCursor
        );
      }

      aboutButtons.forEach((btn) => {
        btn.removeEventListener(
          "mouseenter",
          showAboutCursor
        );

        btn.removeEventListener(
          "mouseleave",
          showCursor
        );
      });

      if (document.body.contains(cursor)) {
        document.body.removeChild(cursor);
      }
    };
  }, [location.pathname]);

  return (
    <div id="top" className="site-shell">
      {location.pathname !== "/contact" && <NavBar />}

      <Routes>
        <Route
          path="/"
          element={
            <>
              <HomePage />
              <ABOUT />
            </>
          }
        />

        <Route path="/contact" element={<Contact />} />
        <Route path="/works" element={<Works />} />
        <Route path="/PAWF" element={<PAWF />} />
        <Route path="/COURSE" element={<COURSE />} />
        <Route path="/PINES" element={<RESORT />} />
        <Route path="/RESUME" element={<Resume />} />
        <Route path="/PERFUME" element={<PERFUME />} />
      </Routes>
    </div>
  );
}

function App() {
  const [loading, setLoading] = useState(true);
  const maintenanceMode = true;

  useEffect(() => {
    const timer = setTimeout(() => {
      setLoading(false);
    }, 1400);

    return () => clearTimeout(timer);
  }, []);

  return maintenanceMode ? (
    <main
      style={{
        minHeight: "100dvh",
        display: "grid",
        placeItems: "center",
        padding: "2rem",
        boxSizing: "border-box",
        backgroundColor: "#252321",
        color: "#F3F0E9",
        textAlign: "center",
        fontFamily: '"Courier New", Courier, monospace',
      }}
    >
      <p
        style={{
          margin: 0,
          fontSize: "clamp(1rem, 2.5vw, 1.5rem)",
          lineHeight: 1.6,
        }}
      >
        I’m busy building.
        <br />
        Nothing to see here right now.
      </p>
    </main>
  ) : (
    <Router>
      {loading && <Loader />}
      <AppContent />
      <ScrollRail />
    </Router>
  );
}

export default App;
